import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable, tap, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalConfigApiService {
  private readonly resourceUrl = '/configuration/frontend/global';
  private readonly otherResourceUrl = '/configuration/frontend/other-configuration';

  private config$: Observable<any> | null = null;

  constructor(private apiService: ApiService) {}

  resetCache(): void {
    this.config$ = null;
  }

  getConfiguration(): Observable<any> {
    if (!this.config$) {
      this.config$ = this.apiService.get(`${this.resourceUrl}`).pipe(shareReplay(1));
    }
    return this.config$;
  }

  updateConfiguration(payload): Observable<any> {
    return this.apiService.put(`${this.resourceUrl}`, payload).pipe(
      tap(() => (this.config$ = null))
    );
  }

  getOtherConfiguration(): Observable<any> {
    return this.apiService.get(`${this.otherResourceUrl}`);
  }
}
